import { SVG_ENUM } from "enums";
import React, { useState } from "react";
import { Button, SVG } from "shared";
import { UserType } from "types/UsersTypes";
import { DeleteUserModal } from "features/users";
import moment from "moment";
import "moment/locale/pl";

interface DeleteAccountProps {
  user: UserType | undefined;
  handleGoBack: () => void;
}

const DeleteAccount: React.FC<DeleteAccountProps> = ({
  user,
  handleGoBack,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const deletedAt = user?.deletedAt;
  const formattedDeleteDate = deletedAt
    ? moment(deletedAt).locale("pl").format("DD.MM.YYYY")
    : null;

  return (
    <div className="profile__right-wrapper profile__right-wrapper--delete">
      <DeleteUserModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
      <div className="profile__right-back" onClick={() => handleGoBack()}>
        <span className="profile__right-back-icon">
          <SVG type={SVG_ENUM.ARROW_BACK} />
        </span>
        Wróć
      </div>
      <h2 className="profile__menu-header">
        <span className="profile__menu-icon profile__menu-icon--right">
          <SVG type={SVG_ENUM.X_SQUARE} />
        </span>
        Usuń konto
      </h2>

      {deletedAt ? (
        <>
          <p className="profile__menu-subheader profile__menu-subheader--alert">
            Twoje konto jest już zaplanowane do usunięcia{" "}
            {user?.package
              ? "po zakończeniu obecnego okresu rozliczeniowego"
              : "w najbliższym czasie"}
            .
          </p>
          <p className="profile__menu-subheader">
            Data zlecenia usunięcia: <b>{formattedDeleteDate}</b>
          </p>
          <p className="profile__menu-subheader">
            Jeśli chcesz anulować usuwanie konta, skontaktuj się z naszym
            zespołem.
          </p>
        </>
      ) : (
        <>
          <p className="profile__menu-subheader">
            Czy na pewno chcą Państwo usunąć konto w aplikacji Reliance?
          </p>
          <p className="profile__menu-subheader">
            {user?.package ? (
              <>
                Konto zostanie usunięte{" "}
                <b>po zakończeniu obecnego okresu rozliczeniowego</b>. Do tego
                czasu dostęp do zakupionego pakietu będzie nadal aktywny.
              </>
            ) : (
              <>
                Konto zostanie usunięte <b>natychmiastowo</b>.
              </>
            )}
          </p>
          <div className="profile__form">
            <Button
              label="Usuń konto"
              size="large"
              onClick={() => setIsOpen(true)}
              styleType="primary"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default DeleteAccount;
